// angular
// .module('HeroPRO')
const HPProjectAdvance = {
    'PA Requested': {
        buttonText: 'Advance eligible',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html',
        stages: [2, 3, 4],
    },
    'PA In Review': {
        buttonText: 'Advance eligible',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceScheduled.html',
        stages: [2, 3, 4],
    },
    'PA Sent': {
        buttonText: 'Advance sent',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceSent.html',
        stages: [4, 5],
    },
    'PA Invoiced': {
        buttonText: 'Advance invoiced',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceInvoiced.html',
        stages: [4, 5],
    },
    'PA Delinquent': {
        buttonText: 'Advance past due',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePastDue.html',
        stages: [4, 5],
    },
    'PA Completed': {
        buttonText: 'Advance repaid',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvancePaidBack.html',
        stages: [4, 5],
    },
    'PA Denied': {
        buttonText: 'Advance unavailable',
        template: 'app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceUnavailable.html',
        stages: [4, 5],
    },
};

export default HPProjectAdvance;



// WEBPACK FOOTER //
// ./src/app/config/constants/hpProjectAdvanceReasons.constant.js